import React, { useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import StaticLayoutInner from '@/layouts/StaticLayoutInner';
import PlusIcon from '@/images/icons/Plus';
import TableLayout from '@/layouts/TableLayout';
import BaseDynamicAPITable from '@/components/Tables/BaseDynamicAPITable';
import NewOptionModal from '@/pages/settings/PaymentOptions/NewOptionModal';
import { OutletContext } from '@/types';
import { humanizeDuration } from '@/utils/durations';
import { fetchAPI } from '@/api';

function PaymentOptions() {
    const { auth, project } = useOutletContext<OutletContext>();

    const [newOptionModalOpen, setNewOptionModalOpen] = useState(false);
    const [newOptionModalMessage, setNewOptionModalMessage] = useState(null);
    const [newOptionModalIsConfirmed, setNewOptionModalIsConfirmed] = useState(false);
    const [newOptionModalError, setNewOptionModalError] = useState(null);

    const button = null;
    // const button = (
    //     <button className="btn-secondary" onClick={() => setNewOptionModalOpen(true)}>
    //         Add new option
    //         <PlusIcon className="w-5 h-5 ml-1 -mr-1" />
    //     </button>
    // );

    const onSettings = async (payment: any) => {
        // try {
        //     const response = await fetchAPI("/plan/update", auth.user.token, {
        //         projectId: project.projectId,
        //         planId: planId,
        //         isHidden: false,
        //     });
        //     const result = await response.json();
        //
        //     if (response.ok && result.plan) {
        //         window.location.reload()
        //     } else {
        //         throw new Error(result.message || "Failed to update the project.");
        //     }
        // } catch (error: any) {
        //     console.error("Error updating project:", error.message);
        //     throw error;
        // }
    }

    // console.log('project', project);

    return (
        <StaticLayoutInner>
            <TableLayout
                title="Payment options"
                description="Here are payment options for this project"
                button={button}
            >
                <BaseDynamicAPITable
                    apiMethod="/project/payment-options"
                    pageSize={10}
                    dataModel={{
                        columns: [
                            {
                                header: "Name",
                                align: "left",
                                render: (row: any) => (
                                    <div className="flex items-center gap-2">
                                        <span className="font-semibold">{row.text}</span>
                                        {row.isTest && <span className="bg-[#F2F2F2] font-semibold leading-[1.3] rounded-[4px] py-[3px] px-1.5">Test</span>}
                                    </div>
                                ),
                                hideHeaderMobile: true,
                                fullWidthMobile: true,
                                width: 35,
                            }, {
                                header: "Status",
                                align: "left",
                                render: (row: any) => <div className="flex flex-wrap gap-1">
                                    {!row.isAvailable 
                                        ? <span className="badge -dot -gray-3">Unavailable</span> 
                                        : (row.isActive 
                                            ? <span className="badge -dot -green">Active</span> 
                                            : <span className="badge -dot -red">Inactive</span>
                                        )
                                    }
                                </div>,
                                hideHeaderMobile: true,
                                fullWidthMobile: true,
                            }
                        ]
                    }}
                    rowLinkTo={(row) => `/settings/payment-options/${row.id}`}
                    rowLinkState={(row) => row}
                />
            </TableLayout>
            {/*<NewOptionModal*/}
            {/*    modalOpen={newOptionModalOpen}*/}
            {/*    setModalOpen={setNewOptionModalOpen}*/}
            {/*    modalMessage={newOptionModalMessage}*/}
            {/*    modalError={newOptionModalError}*/}
            {/*    setModalMessage={setNewOptionModalMessage}*/}
            {/*    setModalError={setNewOptionModalError}*/}
            {/*    isConfirmed={newOptionModalIsConfirmed}*/}
            {/*    setIsConfirmed={setNewOptionModalIsConfirmed}*/}
            {/*    projectId={project.projectId}*/}
            {/*/>*/}
        </StaticLayoutInner>
    );
}

export default PaymentOptions;
